import React, { FC } from 'react';
import { TablePagination } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { TicketsCountSelector, TicketsParamsSelector } from '../../../../store/tickets/selectors';
import { changeTicketsParamsPage, changeTicketParamsPageSize } from '../../../../store/tickets';
import { tt } from '@i18n/tt';
import { ThunkGetTickets } from '../../../../store/tickets/thunks';

const TicketsPagination: FC = () => {
  const params = useAppSelector(TicketsParamsSelector);
  const ticketsCount = useAppSelector(TicketsCountSelector);
  const dispatch = useAppDispatch();
  return (
    <div>
      <TablePagination
        count={ticketsCount}
        page={params.page}
        rowsPerPage={params.pageSize}
        onPageChange={(_event, newPageNumber) => {
          dispatch(changeTicketsParamsPage(newPageNumber));
          dispatch(ThunkGetTickets({ params: { ...params, page: newPageNumber } }));
        }}
        onRowsPerPageChange={event => {
          dispatch(changeTicketParamsPageSize(+event.target.value));
          dispatch(ThunkGetTickets({ params: { ...params, pageSize: +event.target.value } }));
        }}
        rowsPerPageOptions={[10, 20, 50]}
        labelRowsPerPage={tt('table.RowsPerPage')}
      />
    </div>
  );
};

export default TicketsPagination;
